module.exports = __webpack_public_path__ + "f0dc6fe4df49a15934f257751b8beb0e.pdf";